import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from "./Home.module.css";

const Login = ({ setUser }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      navigate('/start');
      return;
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setErrorMessage('メールアドレスとパスワードを入力してください。');
      return;
    }

    try {
      const formData = new URLSearchParams();
      formData.append('username', username);
      formData.append('password', password);

      const response = await fetch('https://api.nagae.biz/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData.detail || 'ログインに失敗しました。');
        return;
      }

      const data = await response.json();
      localStorage.setItem('access_token', data.access_token);

      const userRes = await fetch('https://api.nagae.biz/api/users/me', {
        headers: { 'Authorization': `Bearer ${data.access_token}` },
      });

      if (!userRes.ok) {
        setErrorMessage('ユーザー情報の取得に失敗しました。');
        return;
      }

      const userData = await userRes.json();
      setUser(userData);
      navigate('/start');
    } catch (error) {
      console.error('ログインエラー:', error);
      setErrorMessage('サーバーに接続できません。');
    }
  };

  return (
    <div className={styles.container}>
      <img src="" alt="背景画像" className={styles.backgroundImage} />
      <div className={styles.content}>
        <header className={styles.header}>
          <h1 className={styles.title}>ユーザーログイン</h1>
        </header>
        <div className={styles.card}>
          <form onSubmit={handleLogin} className={styles.loginForm}>
            <div className={styles.formGroup}>
              <label>メールアドレス:</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className={styles.inputField}
              />
            </div>
            <div className={styles.formGroup}>
              <label>パスワード:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className={styles.inputField}
              />
            </div>
            {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
            <button type="submit" className={`${styles.btn} ${styles.btnPrimary}`}>
              ログイン
            </button>
          </form>
          {/* 忘记密码按钮 */}
          <button
            onClick={() => navigate('/forgot-password')}
            className={`${styles.btn} ${styles.btnSecondary}`}
            style={{ marginTop: '10px' }}
          >
            パスワードを忘れた場合はこちら
          </button>
          <button
            onClick={() => navigate('/start')}
            className={`${styles.btn} ${styles.btnSecondary}`}
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
